import { useCallback, useContext } from 'react'
import { trackPostedMessage } from '@components/Analytics/postedMessage'
import { getCachedSpaceDataForAnalytics } from '@components/Analytics/useGatherSpaceDetailsAnalytics'
import { ReplyToMessageContext } from '@components/ReplyToMessageContext/ReplyToMessageContext'
import { ChannelMessageEvent } from '@towns-protocol/sdk'
import { SendTextMessageOptions, useTownsClient } from 'use-towns-client'

export const useEditMessage = (args: { channelId?: string; spaceId?: string }) => {
    const { channelId, spaceId } = args
    const { editMessage } = useTownsClient()
    const { canReplyInline, replyToEventId } = useContext(ReplyToMessageContext)

    const editChannelMessage = useCallback(
        (
            { value, eventId }: { value: string; eventId: string },
            originalEventContent: ChannelMessageEvent,
            msgOptions: SendTextMessageOptions | undefined,
        ) => {
            if (eventId && channelId) {
                editMessage(channelId, eventId, originalEventContent, value, msgOptions)

                trackPostedMessage({
                    spaceId,
                    eventId,
                    channelId,
                    threadId: originalEventContent.threadId,
                    canReplyInline,
                    replyToEventId,
                    messageType: 'edited',
                    ...getCachedSpaceDataForAnalytics(),
                })
            }
        },
        [canReplyInline, channelId, editMessage, replyToEventId, spaceId],
    )

    return { editChannelMessage }
}
